/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The state of a runner.
 */
export const AutoTestRunnerState = /* #__PURE__ */ parsers.exactly('starting', 'waiting_for_image', 'running_setup', 'uploading_image', 'restoring_image', 'running', 'finished');
